"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _colors = require("../config/colors.config");
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Hat = (0, _helpers.getImageByAgent)('party-hat.gif');
var Bulb = (0, _helpers.getImageByAgent)('lightbulb.gif');
var Alert = (0, _helpers.getImageByAgent)('alert.svg');
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    bubble: {
      '&::after': {
        border: 'solid transparent',
        borderBottomColor: _colors.Black[10],
        borderColor: 'rgba(136, 183, 213, 0)',
        borderWidth: 6,
        bottom: '50%',
        content: '""',
        height: 0,
        pointerEvents: 'none',
        position: 'absolute',
        right: '100%',
        transform: 'rotate(-90deg) translateX(-50%)',
        transformOrigin: 'center',
        width: 0
      },
      '&::before': {
        border: 'solid transparent',
        borderBottomColor: '#e8e8e8',
        borderColor: 'rgba(194, 225, 245, 0)',
        borderWidth: 7,
        bottom: '50%',
        content: '""',
        height: 0,
        pointerEvents: 'none',
        position: 'absolute',
        right: '100%',
        transform: 'rotate(-90deg) translateX(-50%)',
        transformOrigin: 'center',
        width: 0
      },
      backgroundColor: theme.palette.background.default,
      border: '1px solid #e8e8e8',
      borderRadius: 8,
      boxShadow: '0px 2px 3px #00000007',
      color: theme.palette.text.secondary,
      flex: '1 0 auto',
      fontFamily: 'Ploni,Arial,sans-serif',
      fontSize: theme.typography.pxToRem(10.5),
      fontWeight: '500',
      lineHeight: 1,
      marginLeft: 10,
      maxWidth: 300,
      minWidth: 120,
      padding: '8px 10px',
      position: 'relative',
      textAlign: 'left',
      wordWrap: 'break-word',
      zIndex: 1
    },
    container: {
      alignItems: 'flex-end',
      display: 'flex',
      flexFlow: 'row nowrap',
      height: function height(props) {
        return props.show ? '100%' : 0;
      },
      opacity: function opacity(props) {
        return props.show ? 1 : 0;
      },
      pointerEvents: 'none'
    },
    icon: {
      '&.Alert': {
        backgroundPositionY: 10,
        width: 22.859
      },
      backgroundColor: 'transparent',
      backgroundImage: function backgroundImage(props) {
        return "url(".concat(props.img, ")");
      },
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      flex: '0 0 auto',
      height: 35,
      width: 33
    }
  };
});
var AlwaysOnTooltip = function AlwaysOnTooltip(_ref) {
  var kind = _ref.kind,
    show = _ref.show,
    className = _ref.className,
    img = _ref.img,
    children = _ref.children,
    bubbleClassName = _ref.bubbleClassName;
  var icons = {
    Alert: Alert,
    Bulb: Bulb,
    Hat: Hat
  };
  var classes = useStyles({
    img: img || icons[kind],
    show: show
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(show ? className : '', " ").concat(classes.container)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.icon, " ").concat(kind)
  }), /*#__PURE__*/_react.default.createElement(_core.Grow, {
    in: show,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: {
      appear: 300,
      enter: 300,
      exit: 300
    },
    style: {
      transitionDelay: '100ms'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.bubble, " ").concat(bubbleClassName)
  }, /*#__PURE__*/_react.default.createElement("span", null, children))));
};
AlwaysOnTooltip.propTypes = {
  bubbleClassName: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  className: _propTypes.default.string,
  img: _propTypes.default.any,
  kind: _propTypes.default.oneOf(['Hat', 'Bulb', 'Alert']),
  show: _propTypes.default.bool
};
AlwaysOnTooltip.defaultProps = {
  bubbleClassName: ''
};
var _default = exports.default = AlwaysOnTooltip;